import React, { useState } from "react";
import {
  Box,
  Button,
  Collapse,
  HStack,
  Text,
  VStack,
} from "@chakra-ui/react";

function evidenceDate(value) {
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime())
    ? "Supporting conversation"
    : new Intl.DateTimeFormat(undefined, { dateStyle: "medium" }).format(parsed);
}

export default function NarrativeCitation({ citation, onOpen, anchorId }) {
  const [showContext, setShowContext] = useState(false);
  if (!citation?.quote) return null;
  const context = citation.context || [];
  return (
    <Box id={anchorId} mt={2.5} pl={3} borderLeftWidth="2px" borderColor="blue.200" scrollMarginTop="96px">
      <Text fontSize="xs" color="gray.600" fontStyle="italic" lineHeight="1.55">
        “{citation.quote}”
      </Text>
      <Text mt={1} fontSize="10px" color="gray.500">
        {citation.rubric_id ? `Rubric ${citation.rubric_id} · ` : ""}
        {citation.dimension_label} · {evidenceDate(citation.occurred_at)}
      </Text>
      <HStack mt={1.5} spacing={3}>
        {context.length > 1 && (
          <Button size="xs" variant="link" colorScheme="gray" onClick={() => setShowContext((value) => !value)}>
            {showContext ? "Hide context" : "Show context"}
          </Button>
        )}
        <Button size="xs" variant="link" colorScheme="blue" onClick={() => onOpen?.(citation)}>
          Open at this quote
        </Button>
      </HStack>
      <Collapse in={showContext} animateOpacity>
        <VStack mt={2.5} spacing={1.5} align="stretch" bg="gray.50" borderRadius="md" p={2.5}>
          {context.map((turn) => {
            const cited = Number(turn.turn_index) === Number(citation.anchor?.turn_index);
            return (
              <Box key={`${citation.evidence_id}:${turn.turn_index}`} bg={cited ? "blue.50" : "transparent"} borderRadius="sm" px={2} py={1}>
                <Text fontSize="10px" fontWeight="bold" color={cited ? "blue.600" : "gray.500"} textTransform="uppercase">
                  {turn.speaker}
                </Text>
                <Text mt={0.5} fontSize="xs" color="gray.700">{turn.text}</Text>
              </Box>
            );
          })}
        </VStack>
      </Collapse>
    </Box>
  );
}
